import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const UserIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M12 14.2649C12.93 14.2649 13.95 14.3999 15.06 14.6699C16.32 14.9849 17.34 15.4049 18.12 15.9299C19.05 16.5449 19.515 17.2349 19.515 17.9999V19.8899H4.48499V17.9999C4.48499 17.2349 4.94998 16.5449 5.87999 15.9299C6.65999 15.4049 7.67998 14.9849 8.93999 14.6699C10.05 14.3999 11.07 14.2649 12 14.2649ZM12 12.3749C11.325 12.3749 10.7025 12.2061 10.1325 11.8686C9.56248 11.5311 9.10874 11.0774 8.77123 10.5074C8.43373 9.93736 8.26499 9.31487 8.26499 8.63986C8.26499 7.96486 8.43373 7.33487 8.77123 6.74986C9.10874 6.16486 9.56248 5.70362 10.1325 5.36611C10.7025 5.02861 11.325 4.85986 12 4.85986C12.675 4.85986 13.2975 5.02861 13.8675 5.36611C14.4375 5.70362 14.8912 6.16486 15.2287 6.74986C15.5662 7.33487 15.735 7.96486 15.735 8.63986C15.735 9.31487 15.5662 9.93736 15.2287 10.5074C14.8912 11.0774 14.4375 11.5311 13.8675 11.8686C13.2975 12.2061 12.675 12.3749 12 12.3749Z'
                fill='currentColor'
            />
        </>
    ),
})

UserIcon.displayName = 'UserIcon'
